import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { store } from './store';
import ProtectedRoute from './components/ProtectedRoute';
import UnprotectedRoute from './components/UnprotectedRoute';
import Login from './pages/Login';
import ConversationPage from './pages/ConversationPage';
import SSOPage from './pages/SSOPage';
import TrainingSessionPage from './pages/TrainingSessionPage';
import { useSubscriptionMonitor } from './hooks/useSubscriptionMonitor';
import SubscriptionStatusAlert from './components/SubscriptionStatusAlert';
import { ToastProvider } from './contexts/ToastContext';
import './App.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

// Inner component to use hooks
const AppContent: React.FC = () => {
  // Monitor subscription status and auto-logout if expired
  useSubscriptionMonitor();

  return (
    <>
      {/* Subscription status warning alert */}
      <SubscriptionStatusAlert />

      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/" element={<Navigate to="/conversation" replace />} />
          <Route
            path="/login"
            element={
              <UnprotectedRoute>
                <Login />
              </UnprotectedRoute>
            }
          />
          <Route path="/sso" element={<SSOPage />} />
          <Route
            path="/conversation"
            element={
              <ProtectedRoute>
                <ConversationPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/training/session/:sessionId"
            element={
              <ProtectedRoute>
                <TrainingSessionPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/conversation" replace />} />
        </Routes>
      </div>
    </>
  );
};

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <ToastProvider>
            <AppContent />
          </ToastProvider>
        </Router>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
